export const safeDivide = (a: number, b: number) => (b ? a / b : 0);
